import SectionReveal from "@/components/shared/SectionReveal";

interface SectionHeadingProps {
  label?: string;
  title: string;
  number?: string;
}

const SectionHeading = ({ label, title, number }: SectionHeadingProps) => {

  return (
    <SectionReveal className="design-heading mb-14 md:mb-20 max-w-2xl">
      <div data-design-heading className="flex items-start gap-6">
        {number && (
          <span className="text-brand-display text-brand-ink leading-none -mt-2 opacity-30">{number}</span>
        )}
        <div>
          {label && (
            <p className="text-brand-label text-brand-ink mb-3">{label}</p>
          )}
          <h2 className="text-brand-title tracking-[-0.03em] uppercase leading-[0.95]">
            {title}
          </h2>
        </div>
      </div>
    </SectionReveal>
  );
};

export default SectionHeading;
